import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import ManageClinic from "./ManageClinic";
import HmsPharmacy from "./HmsPharmacy";
import { useCODData } from "../../context/CODDataContext";
import CryptoJS from "crypto-js";
import {
  useGetDashboardStatus,
  useSendDeviceId,
  useGetClinicSettings,
} from "../../hooks/useProvider";
import useToken from "../../hooks/useToken";

import { useEffect, useRef } from "react";
import useSound from "use-sound";

const MainMenu = ({ providerData, clinicData }) => {
  const location = useLocation();
  const { token } = useToken();
  const hideMenu =
    location.pathname.startsWith("/scribe-service-details") ||
    location.pathname.startsWith("/nurse/scribe-service-details");
  const { isWaiting, isSafWaiting, isSoNotComplete } = useCODData();
  const { mutate: senDeviceId } = useSendDeviceId();
  const { data: menuData } = useGetDashboardStatus();
  // Care On Demand disabled for this clinic → hide the Home (COD dashboard) link.
  // Only hide when confirmed true (fail-open while loading / on error).
  const { data: clinicSettings } = useGetClinicSettings(
    localStorage.getItem("providerId"),
  );
  const codDisabled = clinicSettings?.clinicSettings?.codDisabled === true;
  const showAlert =
    (isWaiting || isSafWaiting || isSoNotComplete) &&
    !location.pathname.includes("/consultations") &&
    !location.pathname.includes("/consultation");

  const restrictedPaths = ["/consultations", "/consultation"];
  const shouldPlaySound =
    providerData?.internalProvider === true &&
    !restrictedPaths.some((path) => location.pathname.includes(path));

  // Ref to store the previous state
  const previousStatusRef = useRef({});

  useEffect(() => {
    console.log("env set", process.env.REACT_APP_ENV);

    if (clinicData?.status === "SUCCESS" && clinicData?.clinicProvider) {
      localStorage?.setItem(
        "clinicId",
        clinicData?.clinicProvider[0]?.clinicId,
      );
    }
  }, [clinicData]);

  const [playEmergencyCare] = useSound(
    process.env.REACT_APP_ALERTU_NOTIFICATION,
    {
      volume: 0.9,
    },
  );
  const [playJingle] = useSound(process.env.REACT_APP_JINGLE_NOTIFICATION, {
    volume: 0.9,
  });

  useEffect(() => {
    if (!providerData?.internalProvider) return; // Ensure sound plays only for internalProvider

    const currentStatus = menuData?.agentDashboardMenuStatus || {};

    const playSounds = () => {
      if (!shouldPlaySound) return;

      // Play specific sound only if the count increased
      if (
        currentStatus.emergencyCareReq > 0 &&
        currentStatus.emergencyCareReq !==
          previousStatusRef.current.emergencyCareReq
      ) {
        playEmergencyCare();
      }

      // Update the previous status
      previousStatusRef.current = { ...currentStatus };
    };

    // Play sounds on state update
    playSounds();

    // Prevent the jingle logic if the path is restricted
    if (!shouldPlaySound) return;

    // Start the interval after the initial timeout
    const jingleInterval = setInterval(() => {
      if (currentStatus.emergencyCareReq > 0) {
        playJingle();
      }
    }, 37000);

    // Clear interval on unmount
    return () => clearInterval(jingleInterval);
  }, [
    menuData?.agentDashboardMenuStatus,
    location.pathname,
    shouldPlaySound,
    playEmergencyCare,
    playJingle,
    providerData?.internalProvider,
  ]);

  useEffect(() => {
    if (token) {
      const tokenObj = {
        deviceToken: token,
        deviceId: "1234",
        userId: providerData?.id,
        deviceType: "web",
      };

      senDeviceId(tokenObj);
    }
  }, [token, providerData?.id, senDeviceId]);

  const handleScribeClick = async (e) => {
    e.preventDefault();

    console.log("Provider email check", providerData?.email);

    const newTab = window.open("", "_blank");

    const data = await getScribeLink();

    if (data?.link) {
      newTab.location.href = data.link;
    } else {
      newTab.close();
      alert(data?.detail || "Failed to open Scribe");
    }
  };

  const handleAnalyzeClick = async (e) => {
    e.preventDefault();

    console.log("Provider email check", providerData?.email);

    const newTab = window.open("", "_blank");

    const key = "hbC2H19lkVbQDfakxcrtNMQdd0FloLyr";
    const iv = "hqLOHUioQ0Qjhuvr";

    const encrypted_user = aesEncrypt(providerData?.email, key, iv);

    const data = await getAnalyzeLink(encrypted_user);

    if (data?.login_link) {
      newTab.location.href = data.login_link;
    } else {
      newTab.close();
      alert(data?.detail || "Failed to open Analyze");
    }
  };

  const getScribeLink = async () => {
    try {
      const key = "hbC2H19lkVbQDfakxcrtNMQdd0FloLyr";
      const iv = "hqLOHUioQ0Qjhuvr";

      const encrypted_user = aesEncrypt(providerData?.email, key, iv);

      console.log("encrypted_user", encrypted_user);

      const res = await fetch(
        process.env.REACT_APP_SCRIBE_SSO_API ||
          "https://qa-scribe.meragoapp.com/api/auth/sso/generate-link",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ encrypted_user }),
        },
      );

      const data = await res.json();

      console.log("API Response:", data);

      return data;
    } catch (err) {
      console.error(err);
    }
  };

  const getAnalyzeLink = async (encryptedEmail) => {
    try {
      const formData = new FormData();
      formData.append("encrypted_email", encryptedEmail);

      const response = await fetch(
        "https://analyze.merago.ai/api/auth/sso/generate-link",
        {
          method: "POST",
          body: formData,
        },
      );

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("API Error:", error);
      return null;
    }
  };

  return (
    // <>
    //   {providerData?.avialableForOthers === true ? (
    //     <Link
    //       to="/dashboard"
    //       className={
    //         location.pathname.includes("/dashboard") ? "sidebar_active" : ""
    //       }
    //     >
    //       {isWaiting && <div className={showAlert ? "red__alert" : ""}></div>}
    //       Home
    //     </Link>
    //   ) : (
    //     <Link
    //       to={
    //         providerData?.eligibleForExpertAnalysis
    //           ? "/second-opinion"
    //           : "/skincare-saf"
    //       }
    //       className={
    //         location.pathname.includes(
    //           providerData?.eligibleForExpertAnalysis
    //             ? "/second-opinion"
    //             : "/skincare-saf"
    //         )
    //           ? "sidebar_active"
    //           : ""
    //       }
    //     >
    //       {(isSafWaiting || isSoNotComplete) && (
    //         <div className={showAlert ? "red__alert" : ""}></div>
    //       )}
    //       Home
    //     </Link>
    //   )}
    //   <Link
    //     to="/my-consultations"
    //     className={
    //       location.pathname.includes("/my-consultations")
    //         ? "sidebar_active"
    //         : ""
    //     }
    //   >
    //     My Consultations
    //   </Link>

    //   {providerData?.isScribeEnabled && (
    //     <Link
    //       to="/ai/scribe"
    //       className={
    //         location.pathname.includes("/ai/scribe") ? "sidebar_active" : ""
    //       }
    //     >
    //       Scribe
    //     </Link>
    //   )}

    //   <Link
    //     to="/ai/intake"
    //     className={
    //       location.pathname.includes("/ai/intake") ? "sidebar_active" : ""
    //     }
    //   >
    //     Intake
    //   </Link>

    //   {providerData?.skincareSAF === true &&
    //     providerData?.avialableForOthers === true && (
    //       //! Display only if the provider has access to skincare saf
    //       <Link
    //         to="/skincare-saf"
    //         className={
    //           location.pathname.includes("/skincare-saf")
    //             ? "sidebar_active"
    //             : ""
    //         }
    //       >
    //         {isSafWaiting && (
    //           <div className={showAlert ? "red__alert" : ""}></div>
    //         )}
    //         Skincare Case Review
    //       </Link>
    //     )}

    //   {providerData?.eligibleForExpertAnalysis &&
    //     providerData?.avialableForOthers && (
    //       <Link
    //         to="/second-opinion"
    //         className={
    //           location.pathname.includes("/second-opinion")
    //             ? "sidebar_active"
    //             : ""
    //         }
    //       >
    //         {isSoNotComplete && (
    //           <div className={showAlert ? "red__alert" : ""}></div>
    //         )}
    //         Second Opinion
    //       </Link>
    //     )}

    //   {providerData?.secondOpinionAdmin && (
    //     <Link
    //       to="/home-care"
    //       className={
    //         location.pathname.includes("/home-care") ? "sidebar_active" : ""
    //       }
    //     >
    //       Home Care
    //     </Link>
    //   )}

    //    {providerData?.internalProvider && (
    //     <Link
    //       to="/pharmacy-care"
    //       className={
    //         location.pathname.includes("/pharmacy-care") ? "sidebar_active" : ""
    //       }
    //     >
    //       Pharmacy
    //     </Link>
    //   )}

    //   {providerData?.hasAccesstoDermaCare === true && (
    //     //! Display only if the provider has access to dermacare
    //     <Link
    //       to="/dermacare"
    //       className={
    //         location.pathname.includes("/dermacare") ? "sidebar_active" : ""
    //       }
    //     >
    //       Dermacare
    //     </Link>
    //   )}
    //   <Link
    //     to="/calander"
    //     className={
    //       location.pathname.includes("/calander") ? "sidebar_active" : ""
    //     }
    //   >
    //     Calendar
    //   </Link>
    //   <Link
    //     to="/billing"
    //     className={
    //       location.pathname.includes("/billing") ? "sidebar_active" : ""
    //     }
    //   >
    //     Payments
    //   </Link>
    //   <Link
    //     to="/patients"
    //     className={
    //       location.pathname.includes("/patients") ? "sidebar_active" : ""
    //     }
    //   >
    //     Patients
    //   </Link>

    //   {clinicData?.clinicProvider?.length > 0 && (
    //     <ManageClinic providerData={providerData} clinicData={clinicData} />
    //   )}

    // </>
    <>
      {/* Home */}
      {!hideMenu &&
        (providerData?.avialableForOthers === true ? (
          // Home → Care On Demand dashboard. Hidden when COD is disabled for
          // this clinic (the dashboard just shows "Please Subscribe").
          codDisabled ? null : (
            <Link
              to="/dashboard"
              className={
                location.pathname.includes("/dashboard") ? "sidebar_active" : ""
              }
            >
              {isWaiting && (
                <div className={showAlert ? "red__alert" : ""}></div>
              )}
              Home
            </Link>
          )
        ) : (
          <Link
            to={
              providerData?.eligibleForExpertAnalysis
                ? "/second-opinion"
                : "/skincare-saf"
            }
            className={
              location.pathname.includes(
                providerData?.eligibleForExpertAnalysis
                  ? "/second-opinion"
                  : "/skincare-saf",
              )
                ? "sidebar_active"
                : ""
            }
          >
            {(isSafWaiting || isSoNotComplete) && (
              <div className={showAlert ? "red__alert" : ""}></div>
            )}
            Home
          </Link>
        ))}

      {/* My Consultations — labelled "Consultations" for scribe-clinic providers */}
      {!hideMenu && (
        <Link
          to="/my-consultations"
          className={
            location.pathname.includes("/my-consultations")
              ? "sidebar_active"
              : ""
          }
        >
          {providerData?.scribeClinicId ? "Consultations" : "My Consultations"}
        </Link>
      )}

      {/* Scribe — stays in SAME position */}
      {/* {providerData?.isScribeEnabled && (
    <Link
      to="/ai/scribe"
      className={
        location.pathname.includes("/ai/scribe") || hideMenu
          ? "sidebar_active"
          : ""
      }
    >
      Scribe
    </Link>
  )} */}

      {providerData?.isScribeEnabled && (
        // <a
        //   href="https://scribe.merago.ai/dashboard"
        //   target="scribeTab"
        //   className={
        //     location.pathname.includes("/ai/scribe") || hideMenu
        //       ? "sidebar_active"
        //       : ""
        //   }
        // >
        //   Scribe
        // </a>
        <a
          href="#"
          onClick={handleScribeClick}
          className={
            location.pathname.includes("/ai/scribe") || hideMenu
              ? "sidebar_active"
              : ""
          }
        >
          Scribe
        </a>
      )}

      {providerData?.isAnalyze && (
     
        <a
          href="#"
          onClick={handleAnalyzeClick}
          className={
            location.pathname.includes("/ai/analyze") || hideMenu
              ? "sidebar_active"
              : ""
          }
        >
          Analyze
        </a>
      )}

      {/* Intake */}

      
      {!hideMenu && providerData?.isIntake &&(
        <Link
          to="/ai/intake"
          className={
            location.pathname.includes("/ai/intake") ? "sidebar_active" : ""
          }
        >
          Intake
        </Link>
      )}

      {/* Skincare Case Review */}
      {!hideMenu &&
        providerData?.skincareSAF &&
        providerData?.avialableForOthers && (
          <Link
            to="/skincare-saf"
            className={
              location.pathname.includes("/skincare-saf")
                ? "sidebar_active"
                : ""
            }
          >
            {isSafWaiting && (
              <div className={showAlert ? "red__alert" : ""}></div>
            )}
            Skincare Case Review
          </Link>
        )}

      {/* Second Opinion */}
      {!hideMenu &&
        providerData?.eligibleForExpertAnalysis &&
        providerData?.avialableForOthers && (
          <Link
            to="/second-opinion"
            className={
              location.pathname.includes("/second-opinion")
                ? "sidebar_active"
                : ""
            }
          >
            {isSoNotComplete && (
              <div className={showAlert ? "red__alert" : ""}></div>
            )}
            Second Opinion
          </Link>
        )}

      {/* Home Care */}
      {!hideMenu && providerData?.secondOpinionAdmin && (
        <Link
          to="/home-care"
          className={
            location.pathname.includes("/home-care") ? "sidebar_active" : ""
          }
        >
          Home Care
        </Link>
      )}

      {/* Pharmacy */}
      {!hideMenu && providerData?.internalProvider && (
        <Link
          to="/pharmacy-care"
          className={
            location.pathname.includes("/pharmacy-care") ? "sidebar_active" : ""
          }
        >
          Pharmacy
        </Link>
      )}

      {/* HMS Pharmacy — HMS-service providers open HIMS Pharmacy Billing (iframe) */}
      {!hideMenu && providerData?.isHmsService && (
        <HmsPharmacy providerData={providerData} />
      )}

      {/* Dermacare */}
      {!hideMenu && providerData?.hasAccesstoDermaCare && (
        <Link
          to="/dermacare"
          className={
            location.pathname.includes("/dermacare") ? "sidebar_active" : ""
          }
        >
          Dermacare
        </Link>
      )}

      {/* Calendar */}
      {!hideMenu && (
        <Link
          to="/calander"
          className={
            location.pathname.includes("/calander") ? "sidebar_active" : ""
          }
        >
          Calendar
        </Link>
      )}

      {/* Payments */}

      {/* {!hideMenu && !providerData?.provider?.scribeClinicId && (
        <Link
          to="/billing"
          className={
            location.pathname.includes("/billing") ? "sidebar_active" : ""
          }
        >
          Payments
        </Link>
      )} */}

      {!hideMenu && !providerData?.scribeClinicId && (
        <Link
          to="/billing"
          className={
            location.pathname.includes("/billing") ? "sidebar_active" : ""
          }
        >
          Payments
        </Link>
      )}

      {/* Patients */}
      {!hideMenu && (
        <Link
          to="/patients"
          className={
            location.pathname.includes("/patients") ? "sidebar_active" : ""
          }
        >
          Patients
        </Link>
      )}

      {/* Manage Clinic */}

      {/* {!hideMenu && clinicData?.clinicProvider?.length > 0 &&  process.env.REACT_APP_ENV != "dev" &&(
        <ManageClinic providerData={providerData} clinicData={clinicData} />
      )} */}

      {!hideMenu &&
        clinicData?.clinicProvider?.length > 0 &&
        process.env.REACT_APP_ENV !== "dev" && (
          <ManageClinic providerData={providerData} clinicData={clinicData} />
        )}
    </>
  );
};

export default MainMenu;

export const aesEncrypt = (plainText, key, iv) => {
  try {
    const keyUtf8 = CryptoJS.enc.Utf8.parse(key);
    const ivUtf8 = CryptoJS.enc.Utf8.parse(iv);
    const textUtf8 = CryptoJS.enc.Utf8.parse(plainText);

    const encrypted = CryptoJS.AES.encrypt(textUtf8, keyUtf8, {
      iv: ivUtf8,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    //return encrypted.toString()
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};
export const aesDecrypt = (cipherText, key, iv) => {
  try {
    const keyUtf8 = CryptoJS.enc.Utf8.parse(key);
    const ivUtf8 = CryptoJS.enc.Utf8.parse(iv);

    const decrypted = CryptoJS.AES.decrypt(cipherText, keyUtf8, {
      iv: ivUtf8,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};
